/*
 *
 * Webhooks constants
 *
 */

export const BASE_ACTION_CONSTANT = 'app/Webhooks';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const UPDATE_WEBHOOK_NOTIFICATIONS_DATA = `${BASE_ACTION_CONSTANT}/UPDATE_WEBHOOK_NOTIFICATIONS_DATA`;

export const GET_WEBHOOK_NOTIFICATIONS = `${BASE_ACTION_CONSTANT}/GET_WEBHOOK_NOTIFICATIONS`;

export const UPDATE_WEBHOOK_NOTIFICATIONS_STATUS = `${BASE_ACTION_CONSTANT}/UPDATE_WEBHOOK_NOTIFICATIONS_STATUS`;

export const HANDLE_UPDATE_WEBHOOK_NOTIFICATIONS_STATUS = `${BASE_ACTION_CONSTANT}/HANDLE_UPDATE_WEBHOOK_NOTIFICATIONS_STATUS`;

export const RESET_DATA = `${BASE_ACTION_CONSTANT}/RESET_DATA`;

export const GET_NOTIFICATION_CHANNEL_DETAILS = `${BASE_ACTION_CONSTANT}/GET_NOTIFICATION_CHANNEL_DETAILS`;

export const ADD_NOTIFICATION_CHANNEL_DETAILS = `${BASE_ACTION_CONSTANT}/ADD_NOTIFICATION_CHANNEL_DETAILS`;

export const HANDLE_ADD_NOTIFICATION_CHANNEL_DETAILS_RESPONSE = `${BASE_ACTION_CONSTANT}/HANDLE_ADD_NOTIFICATION_CHANNEL_DETAILS_RESPONSE`;

export const UPDATE_NOTIFICATION_CHANNEL_DETAILS = `${BASE_ACTION_CONSTANT}/UPDATE_NOTIFICATION_CHANNEL_DETAILS`;

export const HANDLE_UPDATE_NOTIFICATION_CHANNEL_DETAILS = `${BASE_ACTION_CONSTANT}/HANDLE_UPDATE_NOTIFICATION_CHANNEL_DETAILS`;

export const GET_MERCHANT_CONFIG = `${BASE_ACTION_CONSTANT}/GET_MERCHANT_CONFIG`;

export const UPDATE_MERCHANT_CONFIG = `${BASE_ACTION_CONSTANT}/UPDATE_MERCHANT_CONFIG`;

export const TEST_WEBHOOK = `${BASE_ACTION_CONSTANT}/TEST_WEBHOOK`;

export const GET_MERCHANT_KEY = `${BASE_ACTION_CONSTANT}/GET_MERCHANT_KEY`;

export const GET_SUBSCRIPTIONS_WEBHOOK = `${BASE_ACTION_CONSTANT}/GET_SUBSCRIPTIONS_WEBHOOK`;

export const UPDATE_SUBSCRIPTIONS_WEBHOOK = `${BASE_ACTION_CONSTANT}/UPDATE_SUBSCRIPTIONS_WEBHOOK`;

export const GET_CONFIGURED_WEBHOOKS = `${BASE_ACTION_CONSTANT}/GET_CONFIGURED_WEBHOOKS`;

export const GET_ALL_NOTIFICATION_TYPES = `${BASE_ACTION_CONSTANT}/GET_ALL_NOTIFICATION_TYPES`;

export const CREATE_BULK_NOTIFICATION_CHANNEL = `${BASE_ACTION_CONSTANT}/CREATE_BULK_NOTIFICATION_CHANNEL`;

export const GET_ALL_NOTIFICATION_VERSIONS = `${BASE_ACTION_CONSTANT}/GET_ALL_NOTIFICATION_VERSIONS`;

export const UPDATE_WEBHOOK_VERSIONS = `${BASE_ACTION_CONSTANT}/UPDATE_WEBHOOK_VERSIONS`;

export const GET_ABANDONED_CHECKOUT_SECRET_KEY = `${BASE_ACTION_CONSTANT}/GET_ABANDONED_CHECKOUT_SECRET_KEY`;

export const UPDATE_ABANDONED_CHECKOUT_SECRET_KEY = `${BASE_ACTION_CONSTANT}/UPDATE_ABANDONED_CHECKOUT_SECRET_KEY`;

export const SAVE_ABANDONED_CHECKOUT_WEBHOOK = `${BASE_ACTION_CONSTANT}/SAVE_ABANDONED_CHECKOUT_WEBHOOK`;

export const TEST_WEBHOOK_URL = {
  url: '/pg/test-webhook',
  method: 'POST',
};

export const GET_ALL_NOTIFICATION_TYPES_URL = {
  url: '/pg/all-notification-types',
  method: 'GET',
};

export const GET_CONFIGURED_WEBHOOKS_URL = {
  url: '/pg/notification-channel-details',
  method: 'GET',
};

export const GET_WEBHOOK_NOTIFICATIONS_URL = {
  url: '/pg/notification-config/toggle',
  method: 'GET',
};

export const UPDATE_WEBHOOK_NOTIFICATIONS_STATUS_URL = {
  url: '/pg/notification-config',
  method: 'POST',
};

export const GET_NOTIFICATION_CONFIG_VERSION_URL = {
  url: '/pg/notification-config/version',
  method: 'GET',
};

export const GET_SUBSCRIPTIONS_WEBHOOK_URL = {
  url: '/pg/subscription/notification-config/webhook',
  method: 'GET',
};

export const UPDATE_SUBSCRIPTIONS_WEBHOOK_URL = {
  url: '/pg/subscription/notification-config/webhook',
  method: 'PUT',
};

export const CREATE_BULK_NOTIFICATION_CHANNEL_URL = {
  url: '/pg/notification-channel-details',
  method: 'POST',
};

export const GET_ABANDONED_CHECKOUT_SECRET_KEY_URL = {
  url: '/pg/merchant-pg-config',
  method: 'GET',
};

export const SAVE_ABANDONED_CHECKOUT_WEBHOOK_URL = {
  url: '/pg/merchant-pg-config',
  method: 'POST',
};

export const UPDATE_ABANDONED_CHECKOUT_SECRET_KEY_URL = {
  url: '/pg/merchant-pg-config',
  method: 'PATCH',
};

export const SUCCESS_PAYMENT = 'SUCCESS_PAYMENT';

export const PAYMENT_FORM_ORDER_WEBHOOK = 'PAYMENT_FORM_ORDER_WEBHOOK';

export const PAYMENT_LINK_EVENT = 'PAYMENT_LINK_EVENT';

export const FAILED_PAYMENT = 'FAILED_PAYMENT';

export const USER_DROPPED_PAYMENT = 'USER_DROPPED_PAYMENT';

export const SETTLEMENT_SUCCESS = 'SETTLEMENT_SUCCESS';

export const SETTLEMENT_FAILED = 'SETTLEMENT_FAILED';

export const SETTLEMENT_INITIATED = 'SETTLEMENT_INITIATED';

export const SETTLEMENT_REVERSED = 'SETTLEMENT_REVERSED';

export const VENDOR_SETTLEMENT_INITIATED = 'VENDOR_SETTLEMENT_INITIATED';

export const VENDOR_SETTLEMENT_SUCCESS = 'VENDOR_SETTLEMENT_SUCCESS';

export const VENDOR_SETTLEMENT_FAILED = 'VENDOR_SETTLEMENT_FAILED';

export const VENDOR_SETTLEMENT_REVERSED = 'VENDOR_SETTLEMENT_REVERSED';

export const NOTIFY_URL_VALUE = 'NOTIFY_URL';

export const PAYMENT_SUCCESS_WEBHOOK_KNOW_MORE_URL =
  'https://www.cashfree.com/docs/payments/no-code/payment-forms/webhooks';

export const TRANSACTION_WEBHOOK_KNOW_MORE_URL =
  'https://www.cashfree.com/docs/payments/online/webhooks/overview';

export const CREATE_ORDER_API_DOC_LINK =
  'https://docs.cashfree.com/reference/createorder';

export const SUBSCRIPTION_EVENTS_API_DOC_LINK =
  'https://docs.cashfree.com/reference/subscription-webhooks';

export const GENERATE_API_KEYS = 'GENERATE_API_KEYS';

export const PAYMENTS = 'payments';

export const REFUNDS = 'refunds';

export const SETTLEMENTS = 'settlements';

export const PAYMENT_LINK = 'payment-link';

export const PAYMENT_FORM = 'payment-form';

export const INSTRUMENT = 'instrument';

export const VENDOR_SETTLEMENTS = 'vendor-settlements';

export const SUBSCRIPTIONS = 'subscriptions';

export const SUBSCRIPTIONS_WEBHOOK = 'SUBSCRIPTIONS_WEBHOOK';

export const TRANSACTION = 'payment-gateway';

// export const PAYMENT_GATEWAY = 'paymentGateway';

export const NOTIFY_URL = 'notify-url';

export const NAVIGATION_BAR_OPTIONS = [
  {
    key: TRANSACTION,
    text: 'Payment Gateway',
  },
  {
    key: PAYMENT_LINK,
    text: 'Payment Link',
  },
  {
    key: PAYMENT_FORM,
    text: 'Payment Form',
  },
  //   {
  //     key: NOTIFY_URL,
  //     text: 'Notify URL',
  //   },
  {
    key: SUBSCRIPTIONS,
    text: 'Subscriptions',
  },
];

export const WEBHOOK = 'WEBHOOK';

export const REFUND = 'REFUND';

export const INSTRUMENT_ACTIVE = 'INSTRUMENT_ACTIVE';

export const PAYMENTS_WEBHOOK_DATA = [
  {
    title: 'Payment Success',
    type: SUCCESS_PAYMENT,
    channel: WEBHOOK,
  },
  {
    title: 'Payment Failed',
    type: FAILED_PAYMENT,
    channel: WEBHOOK,
  },
  {
    title: 'User Dropped',
    type: USER_DROPPED_PAYMENT,
    channel: WEBHOOK,
  },
];

export const REFUNDS_WEBHOOK_DATA = [
  {
    type: REFUND,
    channel: WEBHOOK,
  },
];

export const INSTRUMENT_WEBHOOK_DATA = [
  {
    type: INSTRUMENT_ACTIVE,
    channel: WEBHOOK,
  },
];

export const PAYMENT_FORMS_WEBHOOK_DATA = [
  {
    type: PAYMENT_FORM_ORDER_WEBHOOK,
    channel: WEBHOOK,
  },
];

export const PAYMENT_LINKS_WEBHOOK_DATA = [
  {
    type: PAYMENT_LINK_EVENT,
    channel: WEBHOOK,
  },
];

export const SETTLEMENTS_WEBHOOK_DATA = [
  {
    title: 'Settlement Success',
    type: SETTLEMENT_SUCCESS,
    channel: WEBHOOK,
  },
  {
    title: 'Settlement Failed',
    type: SETTLEMENT_FAILED,
    channel: WEBHOOK,
  },
  {
    title: 'Settlement Initiated',
    type: SETTLEMENT_INITIATED,
    channel: WEBHOOK,
  },
  {
    title: 'Settlement Reversed',
    type: SETTLEMENT_REVERSED,
    channel: WEBHOOK,
  },
];

export const VENDOR_SETTLEMENTS_DATA = [
  {
    title: 'Vendor Settlement Success',
    type: VENDOR_SETTLEMENT_SUCCESS,
    channel: WEBHOOK,
  },
  {
    title: 'Vendor Settlement Failed',
    type: VENDOR_SETTLEMENT_FAILED,
    channel: WEBHOOK,
  },
  {
    title: 'Vendor Settlement Initiated',
    type: VENDOR_SETTLEMENT_INITIATED,
    channel: WEBHOOK,
  },
  {
    title: 'Vendor Settlement Reversed',
    type: VENDOR_SETTLEMENT_REVERSED,
    channel: WEBHOOK,
  },
];

export const SUBSCRIPTIONS_WEBHOOK_DATA = [
  {
    type: SUBSCRIPTIONS_WEBHOOK,
    channel: WEBHOOK,
  },
];

export const TRANSACTION_WEBHOOK = 'TRANSACTION_WEBHOOK';

export const TRANSACTION_WEBHOOK_DATA = [
  { type: TRANSACTION_WEBHOOK, channel: WEBHOOK },
];

export const WEBHOOK_NOTIFICATIONS_DATA = {
  [TRANSACTION]: {
    key: TRANSACTION,
    title: 'Transaction',
    data: TRANSACTION_WEBHOOK_DATA,
  },
  [PAYMENTS]: {
    key: PAYMENTS,
    title: 'Payments',
    data: PAYMENTS_WEBHOOK_DATA,
  },
  [REFUNDS]: {
    key: REFUNDS,
    title: 'Refunds',
    data: REFUNDS_WEBHOOK_DATA,
  },
  [SETTLEMENTS]: {
    key: SETTLEMENTS,
    title: 'Settlements',
    data: SETTLEMENTS_WEBHOOK_DATA,
  },
  [VENDOR_SETTLEMENTS]: {
    key: VENDOR_SETTLEMENTS,
    title: 'Vendor Settlements',
    data: VENDOR_SETTLEMENTS_DATA,
  },
  [PAYMENT_LINK]: {
    key: PAYMENT_LINK,
    title: 'Payment Link',
    data: PAYMENT_LINKS_WEBHOOK_DATA,
  },
  [PAYMENT_FORM]: {
    key: PAYMENT_FORM,
    title: 'Payment Form',
    data: PAYMENT_FORMS_WEBHOOK_DATA,
  },
  [INSTRUMENT]: {
    key: INSTRUMENT,
    title: 'Instrument',
    data: INSTRUMENT_WEBHOOK_DATA,
  },
  [SUBSCRIPTIONS]: {
    key: SUBSCRIPTIONS,
    title: 'Subscriptions',
    data: SUBSCRIPTIONS_WEBHOOK_DATA,
  },
};

export const HEADINGS = {
  [TRANSACTION]: [
    {
      key: 'url',
      displayName: 'URL',
      width: 2,
    },
    {
      key: 'cfApiVersion',
      displayName: 'Webhook version',
      width: 0.03,
    },
    {
      key: 'events',
      displayName: 'Events',
      width: 1.5,
    },
    {
      key: 'actions',
      displayName: 'Actions',
      width: 1.5,
    },
  ],
  [NOTIFY_URL]: [
    {
      key: 'event',
      displayName: 'Subscribed events',
      width: 0.05,
    },
    {
      key: 'versions',
      displayName: 'Running versions',
      width: 0.05,
    },
    {
      key: 'actions',
      displayName: 'Actions',
      width: 0.04,
    },
  ],
  [PAYMENTS]: [
    {
      key: 'url',
      displayName: 'URL',
      width: 0.08,
    },
    // {
    //   key: 'status',
    //   displayName: 'Status',
    //   width: 0.02,
    // },
    {
      key: 'cfApiVersion',
      displayName: 'Running On',
      width: 0.04,
    },
    // {
    //   key: 'test',
    //   displayName: '',
    //   width: 0.005,
    //   align: 'right',
    // },
    {
      key: 'toggle',
      displayName: '',
      width: 0.006,
      align: 'right',
    },
    // {
    //   key: 'switch',
    //   displayName: '',
    //   width: 0.005,
    // },
  ],
  [REFUNDS]: [
    {
      key: 'url',
      displayName: 'URL',
      width: 0.08,
    },
    {
      key: 'toggle',
      displayName: '',
      width: 0.02,
      align: 'right',
    },
  ],
  [PAYMENT_LINK]: [
    {
      key: 'url',
      displayName: 'URL',
      width: 0.08,
    },
    {
      key: 'toggle',
      displayName: '',
      width: 0.02,
      align: 'right',
    },
  ],
  [SETTLEMENTS]: [
    {
      key: 'url',
      displayName: 'URL',
      width: 0.08,
    },
    {
      key: 'toggle',
      displayName: '',
      width: 0.02,
      align: 'right',
    },
  ],
  [VENDOR_SETTLEMENTS]: [
    {
      key: 'url',
      displayName: 'URL',
      width: 0.08,
    },
    {
      key: 'toggle',
      displayName: '',
      width: 0.02,
      align: 'right',
    },
  ],
  [INSTRUMENT]: [
    {
      key: 'url',
      displayName: 'URL',
      width: 0.08,
    },
    {
      key: 'toggle',
      displayName: '',
      width: 0.02,
      align: 'right',
    },
  ],
  [PAYMENT_FORM]: [
    {
      key: 'url',
      displayName: 'URL',
      width: 0.08,
    },
    {
      key: 'toggle',
      displayName: '',
      width: 0.02,
      align: 'right',
    },
  ],
  [SUBSCRIPTIONS]: [
    {
      key: 'url',
      displayName: 'URL',
      width: 2.2,
    },
    {
      key: 'cfApiVersion',
      displayName: 'Webhook version',
      width: 0.03,
    },
    {
      key: 'events',
      displayName: 'Events',
      width: 1,
    },
    {
      key: 'actions',
      displayName: 'Actions',
      width: 1,
    },
  ],
};

export const SUBSCRIPTIONS_WEBHOOK_VERSION_2023 = '2023-08-01';

export const SUBSCRIPTIONS_WEBHOOK_VERSION_2025 = '2025-01-01';

export const SUBSCRIPTIONS_WEBHOOK_VERSION_2022 = '2022-09-01';

export const PAYMENTS_WEBHOOK_VERSION_2021 = '2021-09-21';

export const PAYMENTS_WEBHOOK_VERSION_2022 = '2022-09-01';

export const PAYMENTS_WEBHOOK_VERSION_2022_1 = '2022-02-09';

export const PAYMENTS_WEBHOOK_VERSION_2023 = '2023-08-01';

export const PAYMENTS_WEBHOOK_VERSION_2025 = '2025-01-01';

export const INCIDENT = 'INCIDENT';

export const DISPUTE_CREATED = 'DISPUTE_CREATED';

export const DISPUTE_CLOSED = 'DISPUTE_CLOSED';

export const SUCCESS_PAYMENT_TDR = 'SUCCESS_PAYMENT_TDR';

export const WEBHOOK_OPTIONS = {
  [TRANSACTION]: [
    {
      key: SUCCESS_PAYMENT,
      text: 'Payment Success',
      value: SUCCESS_PAYMENT,
    },
    {
      key: FAILED_PAYMENT,
      text: 'Payment Failed',
      value: FAILED_PAYMENT,
    },
    {
      key: USER_DROPPED_PAYMENT,
      text: 'User Dropped',
      value: USER_DROPPED_PAYMENT,
    },
    {
      key: SETTLEMENT_SUCCESS,
      text: 'Settlement Success',
      value: SETTLEMENT_SUCCESS,
    },
    {
      key: SETTLEMENT_FAILED,
      text: 'Settlement Failed',
      value: SETTLEMENT_FAILED,
    },
    {
      key: SETTLEMENT_INITIATED,
      text: 'Settlement Initiated',
      value: SETTLEMENT_INITIATED,
    },
    {
      key: SETTLEMENT_REVERSED,
      text: 'Settlement Reversed',
      value: SETTLEMENT_REVERSED,
    },
    {
      key: VENDOR_SETTLEMENT_SUCCESS,
      text: 'Vendor Settlement Success',
      value: VENDOR_SETTLEMENT_SUCCESS,
    },
    {
      key: VENDOR_SETTLEMENT_FAILED,
      text: 'Vendor Settlement Failed',
      value: VENDOR_SETTLEMENT_FAILED,
    },
    {
      key: VENDOR_SETTLEMENT_INITIATED,
      text: 'Vendor Settlement Initiated',
      value: VENDOR_SETTLEMENT_INITIATED,
    },
    {
      key: VENDOR_SETTLEMENT_REVERSED,
      text: 'Vendor Settlement Reversed',
      value: VENDOR_SETTLEMENT_REVERSED,
    },
    {
      key: REFUND,
      text: 'Refund',
      value: REFUND,
    },
    {
      key: INCIDENT,
      text: 'Incident',
      value: INCIDENT,
    },
    {
      key: DISPUTE_CREATED,
      text: 'Dispute Created',
      value: DISPUTE_CREATED,
    },
    {
      key: SUCCESS_PAYMENT_TDR,
      text: 'Success Payment Tdr',
      value: SUCCESS_PAYMENT_TDR,
    },
    {
      key: INSTRUMENT_ACTIVE,
      text: 'Instrument Active',
      value: INSTRUMENT_ACTIVE,
    },
  ],
};

export const WEBHOOK_REQUEST_DATA = {
  [SUCCESS_PAYMENT]: {
    [PAYMENTS_WEBHOOK_VERSION_2021]: {
      data: {
        order: {
          order_id: 'dragon019',
          order_amount: 1,
          order_currency: 'INR',
          order_tags: null,
        },
        payment: {
          cf_payment_id: 1373936,
          payment_status: 'SUCCESS',
          payment_amount: 1,
          payment_currency: 'INR',
          payment_message: 'Transaction Successful',
          payment_time: '2022-03-08T22:36:36+05:30',
          bank_reference: '22120',
          auth_id: '10000',
          payment_method: {},
          payment_group: 'wallet',
        },
        customer_details: {
          customer_name: 'YOGESH',
          customer_id: 'dragon002',
          customer_email: 'dgon@cashfree.com',
          customer_phone: '9611199227',
        },
      },
      event_time: '2022-03-08T22:36:40+05:30',
      type: 'PAYMENT_SUCCESS_WEBHOOK',
    },
    [PAYMENTS_WEBHOOK_VERSION_2022]: {
      data: {
        order: {
          order_id: 'order_OFR_2',
          order_amount: 2,
          order_currency: 'INR',
          order_tags: null,
        },
        payment: {
          cf_payment_id: 1453002795,
          payment_status: 'SUCCESS',
          payment_amount: 1,
          payment_currency: 'INR',
          payment_message: '00::Transaction success',
          payment_time: '2022-12-15T12:20:29+05:30',
          bank_reference: '234928698581',
          auth_id: null,
          payment_method: {
            upi: {
              channel: null,
              upi_id: '9611199227@paytm',
            },
          },
          payment_group: 'upi',
        },
        customer_details: {
          customer_name: null,
          customer_id: '7112AAA812234',
          customer_email: 'miglaniyogesh7@gmail.com',
          customer_phone: '9908734801',
        },
        payment_gateway_details: {
          gateway_name: 'CASHFREE',
          gateway_order_id: '1580762800',
          gateway_payment_id: '1453002795',
          gateway_status_code: null,
        },
        payment_offers: [
          {
            offer_id: '0f05e1d0-fbf8-4c9c-a1f0-814c7b2abdba',
            offer_type: 'DISCOUNT',
            offer_meta: {
              offer_title: '50% off on UPI',
              offer_description: '50% off for testing',
              offer_code: 'UPI50',
              offer_start_time: '2022-11-09T06:23:25.972Z',
              offer_end_time: '2023-02-27T18:30:00Z',
            },
            offer_redemption: {
              redemption_status: 'SUCCESS',
              discount_amount: 1,
              cashback_amount: 0,
            },
          },
        ],
      },
      event_time: '2023-01-03T11:16:10+05:30',
      type: 'PAYMENT_SUCCESS_WEBHOOK',
    },
  [PAYMENTS_WEBHOOK_VERSION_2023]: {
    data: {
      order: {
        order_id: 'order_OFR_2',
        order_amount: 2,
        order_currency: 'INR',
        order_tags: null,
      },
      payment: {
        cf_payment_id: "1453002795",
        payment_status: 'SUCCESS',
        payment_amount: 1,
        payment_currency: 'INR',
        payment_message: '00::Transaction success',
        payment_time: '2022-12-15T12:20:29+05:30',
        bank_reference: '234928698581',
        auth_id: null,
        payment_method: {
          upi: {
            channel: null,
            upi_id: '9611199227@paytm',
          },
        },
        payment_group: 'upi',
      },
      customer_details: {
        customer_name: null,
        customer_id: '7112AAA812234',
        customer_email: 'miglaniyogesh7@gmail.com',
        customer_phone: '9908734801',
      },
      payment_gateway_details: {
        gateway_name: 'CASHFREE',
        gateway_order_id: '1580762800',
        gateway_payment_id: '1453002795',
        gateway_status_code: null,
      },
      payment_offers: [
        {
          offer_id: '0f05e1d0-fbf8-4c9c-a1f0-814c7b2abdba',
          offer_type: 'DISCOUNT',
          offer_meta: {
            offer_title: '50% off on UPI',
            offer_description: '50% off for testing',
            offer_code: 'UPI50',
            offer_start_time: '2022-11-09T06:23:25.972Z',
            offer_end_time: '2023-02-27T18:30:00Z',
          },
          offer_redemption: {
            redemption_status: 'SUCCESS',
            discount_amount: 1,
            cashback_amount: 0,
          },
        },
      ],
    },
    event_time: '2023-08-01T11:16:10+05:30',
    type: 'PAYMENT_SUCCESS_WEBHOOK',
  },
},
  [FAILED_PAYMENT]: {
    [PAYMENTS_WEBHOOK_VERSION_2021]: {
      data: {
        order: {
          order_id: 'dragon019',
          order_amount: 1,
          order_currency: 'INR',
          order_tags: null,
        },
        payment: {
          cf_payment_id: 1373936,
          payment_status: 'SUCCESS',
          payment_amount: 1,
          payment_currency: 'INR',
          payment_message: 'Transaction Successful',
          payment_time: '2022-03-08T22:36:36+05:30',
          bank_reference: '22120',
          auth_id: '10000',
          payment_method: {},
          payment_group: 'wallet',
        },
        customer_details: {
          customer_name: 'YOGESH',
          customer_id: 'dragon002',
          customer_email: 'dgon@cashfree.com',
          customer_phone: '9611199227',
        },
      },
      event_time: '2022-03-08T22:36:40+05:30',
      type: 'PAYMENT_FAILED_WEBHOOK',
    },
    [PAYMENTS_WEBHOOK_VERSION_2022]: {
      data: {
        order: {
          order_id: 'order_OFR_2',
          order_amount: 2,
          order_currency: 'INR',
          order_tags: null,
        },
        payment: {
          cf_payment_id: 1453002795,
          payment_status: 'SUCCESS',
          payment_amount: 1,
          payment_currency: 'INR',
          payment_message: '00::Transaction success',
          payment_time: '2022-12-15T12:20:29+05:30',
          bank_reference: '234928698581',
          auth_id: null,
          payment_method: {
            upi: {
              channel: null,
              upi_id: '9611199227@paytm',
            },
          },
          payment_group: 'upi',
        },
        customer_details: {
          customer_name: null,
          customer_id: '7112AAA812234',
          customer_email: 'miglaniyogesh7@gmail.com',
          customer_phone: '9908734801',
        },
        payment_gateway_details: {
          gateway_name: 'CASHFREE',
          gateway_order_id: '1580762800',
          gateway_payment_id: '1453002795',
          gateway_status_code: null,
        },
        payment_offers: [
          {
            offer_id: '0f05e1d0-fbf8-4c9c-a1f0-814c7b2abdba',
            offer_type: 'DISCOUNT',
            offer_meta: {
              offer_title: '50% off on UPI',
              offer_description: '50% off for testing',
              offer_code: 'UPI50',
              offer_start_time: '2022-11-09T06:23:25.972Z',
              offer_end_time: '2023-02-27T18:30:00Z',
            },
            offer_redemption: {
              redemption_status: 'SUCCESS',
              discount_amount: 1,
              cashback_amount: 0,
            },
          },
        ],
      },
      event_time: '2023-01-03T11:16:10+05:30',
      type: 'PAYMENT_FAILED_WEBHOOK',
    },
    [PAYMENTS_WEBHOOK_VERSION_2023]: {
      data: {
        order: {
          order_id: 'order_OFR_2',
          order_amount: 2,
          order_currency: 'INR',
          order_tags: null,
        },
        payment: {
          cf_payment_id: "1453002795",
          payment_status: 'SUCCESS',
          payment_amount: 1,
          payment_currency: 'INR',
          payment_message: '00::Transaction success',
          payment_time: '2023-08-01T12:20:29+05:30',
          bank_reference: '234928698581',
          auth_id: null,
          payment_method: {
            upi: {
              channel: null,
              upi_id: '9611199227@paytm',
            },
          },
          payment_group: 'upi',
        },
        customer_details: {
          customer_name: null,
          customer_id: '7112AAA812234',
          customer_email: 'miglaniyogesh7@gmail.com',
          customer_phone: '9908734801',
        },
        error_details: {  
          error_code: "GATEWAY_ERROR",  
          error_description: "AMOUNT SHOULD BE WITHIN RANGE BETWEEN 20.00 TO 500000.00. for this bank",  
          error_reason: "invalid_amount",  
          error_source: "cashfree",  
          error_subcode_raw: "U09"
        },
        payment_gateway_details: {
          gateway_name: 'CASHFREE',
          gateway_order_id: '1580762800',
          gateway_payment_id: '1453002795',
          gateway_status_code: null,
        },
        payment_offers: [
          {
            offer_id: '0f05e1d0-fbf8-4c9c-a1f0-814c7b2abdba',
            offer_type: 'DISCOUNT',
            offer_meta: {
              offer_title: '50% off on UPI',
              offer_description: '50% off for testing',
              offer_code: 'UPI50',
              offer_start_time: '2022-11-09T06:23:25.972Z',
              offer_end_time: '2023-02-27T18:30:00Z',
            },
            offer_redemption: {
              redemption_status: 'SUCCESS',
              discount_amount: 1,
              cashback_amount: 0,
            },
          },
        ],
      },
      event_time: '2023-08-01T11:16:10+05:30',
      type: 'PAYMENT_FAILED_WEBHOOK',
    },
  },
  [USER_DROPPED_PAYMENT]: {
    [PAYMENTS_WEBHOOK_VERSION_2021]: {
      data: {
        order: {
          order_id: 'dragon019',
          order_amount: 1,
          order_currency: 'INR',
          order_tags: null,
        },
        payment: {
          cf_payment_id: 1373936,
          payment_status: 'SUCCESS',
          payment_amount: 1,
          payment_currency: 'INR',
          payment_message: 'Transaction Successful',
          payment_time: '2022-03-08T22:36:36+05:30',
          bank_reference: '22120',
          auth_id: '10000',
          payment_method: {},
          payment_group: 'wallet',
        },
        customer_details: {
          customer_name: 'YOGESH',
          customer_id: 'dragon002',
          customer_email: 'dgon@cashfree.com',
          customer_phone: '9611199227',
        },
      },
      event_time: '2022-03-08T22:36:40+05:30',
      type: 'PAYMENT_USER_DROPPED_WEBHOOK',
    },
    [PAYMENTS_WEBHOOK_VERSION_2022]: {
      data: {
        order: {
          order_id: 'order_OFR_2',
          order_amount: 2,
          order_currency: 'INR',
          order_tags: null,
        },
        payment: {
          cf_payment_id: 1453002795,
          payment_status: 'SUCCESS',
          payment_amount: 1,
          payment_currency: 'INR',
          payment_message: '00::Transaction success',
          payment_time: '2022-12-15T12:20:29+05:30',
          bank_reference: '234928698581',
          auth_id: null,
          payment_method: {
            upi: {
              channel: null,
              upi_id: '9611199227@paytm',
            },
          },
          payment_group: 'upi',
        },
        customer_details: {
          customer_name: null,
          customer_id: '7112AAA812234',
          customer_email: 'miglaniyogesh7@gmail.com',
          customer_phone: '9908734801',
        },
        payment_gateway_details: {
          gateway_name: 'CASHFREE',
          gateway_order_id: '1580762800',
          gateway_payment_id: '1453002795',
          gateway_status_code: null,
        },
        payment_offers: [
          {
            offer_id: '0f05e1d0-fbf8-4c9c-a1f0-814c7b2abdba',
            offer_type: 'DISCOUNT',
            offer_meta: {
              offer_title: '50% off on UPI',
              offer_description: '50% off for testing',
              offer_code: 'UPI50',
              offer_start_time: '2022-11-09T06:23:25.972Z',
              offer_end_time: '2023-02-27T18:30:00Z',
            },
            offer_redemption: {
              redemption_status: 'SUCCESS',
              discount_amount: 1,
              cashback_amount: 0,
            },
          },
        ],
      },
      event_time: '2023-01-03T11:16:10+05:30',
      type: 'PAYMENT_USER_DROPPED_WEBHOOK',
    },
    [PAYMENTS_WEBHOOK_VERSION_2023]: {
      data: {
        order: {
          order_id: 'order_OFR_2',
          order_amount: 2,
          order_currency: 'INR',
          order_tags: null,
        },
        payment: {
          cf_payment_id: '1453002795',
          payment_status: 'SUCCESS',
          payment_amount: 1,
          payment_currency: 'INR',
          payment_message: '00::Transaction success',
          payment_time: '2023-08-01T12:20:29+05:30',
          bank_reference: '234928698581',
          auth_id: null,
          payment_method: {
            upi: {
              channel: null,
              upi_id: '9611199227@paytm',
            },
          },
          payment_group: 'upi',
        },
        customer_details: {
          customer_name: null,
          customer_id: '7112AAA812234',
          customer_email: 'miglaniyogesh7@gmail.com',
          customer_phone: '9908734801',
        },
        payment_gateway_details: {
          gateway_name: 'CASHFREE',
          gateway_order_id: '1580762800',
          gateway_payment_id: '1453002795',
          gateway_status_code: null,
        },
        payment_offers: [
          {
            offer_id: '0f05e1d0-fbf8-4c9c-a1f0-814c7b2abdba',
            offer_type: 'DISCOUNT',
            offer_meta: {
              offer_title: '50% off on UPI',
              offer_description: '50% off for testing',
              offer_code: 'UPI50',
              offer_start_time: '2022-11-09T06:23:25.972Z',
              offer_end_time: '2023-02-27T18:30:00Z',
            },
            offer_redemption: {
              redemption_status: 'SUCCESS',
              discount_amount: 1,
              cashback_amount: 0,
            },
          },
        ],
      },
      event_time: '2023-08-01T11:16:10+05:30',
      type: 'PAYMENT_USER_DROPPED_WEBHOOK',
    },
  },
  [REFUND]: {
    data: {
      refund: {
        cf_refund_id: 34198,
        cf_payment_id: 1234,
        refund_id: 'REF_1645610245762635',
        order_id: '3hD-hgxkW27',
        refund_amount: 5.0,
        refund_currency: 'INR',
        entity: 'Refund',
        refund_type: 'MERCHANT_INITIATED',
        refund_arn: '123356',
        refund_status: 'SUCCESS',
        status_description: 'Refund processed successfully',
        created_at: '2022-02-23T15:27:26+05:30',
        processed_at: '2022-02-23T15:28:36+05:30',
        refund_charge: 0,
        refund_note: 'triggered by CashFree',
        refund_splits: null,
        metadata: null,
        refund_mode: 'STANDARD',
      },
    },
    event_time: '2022-02-23T15:28:36+05:30',
    // version: 1, ??
    type: 'REFUND_STATUS_WEBHOOK',
  },
  [SETTLEMENT_INITIATED]: {
    data: {
      settlement: {
        adjustment: 0,
        amount_settled: 5,
        payment_amount: 5,
        payment_from: '2022-03-17',
        payment_till: '2022-03-17',
        reason: null,
        service_charge: 0,
        service_tax: 0,
        settled_on: '2022-03-17T14:21:18+05:30',
        settlement_amount: 5,
        settlement_id: 1155353,
        settlement_initiated_on: '2022-03-17T14:29:21+05:30',
        status: 'INITIATED',
        utr: 'N076221079016329',
      },
    },
    event_time: '2022-03-17T14:29:23+05:30',
    // version: 1, ??
    type: 'SETTLEMENT_INITIATED',
  },
  [SETTLEMENT_SUCCESS]: {
    data: {
      settlement: {
        adjustment: 0,
        amount_settled: 5,
        payment_amount: 5,
        payment_from: '2022-03-17',
        payment_till: '2022-03-17',
        reason: null,
        service_charge: 0,
        service_tax: 0,
        settled_on: '2022-03-17T14:21:18+05:30',
        settlement_amount: 5,
        settlement_id: 1155353,
        settlement_initiated_on: '2022-03-17T14:29:21+05:30',
        status: 'SUCCESS',
        utr: 'N076221079016329',
      },
    },
    event_time: '2022-03-17T14:29:23+05:30',
    // version: 1, ??
    type: 'SETTLEMENT_SUCCESS',
  },
  [SETTLEMENT_FAILED]: {
    data: {
      settlement: {
        adjustment: 0,
        amount_settled: 5,
        payment_amount: 5,
        payment_from: '2022-03-17',
        payment_till: '2022-03-17',
        reason: '<REASON>',
        service_charge: 0,
        service_tax: 0,
        settled_on: '2022-03-17T14:21:18+05:30',
        settlement_amount: 5,
        settlement_id: 1155353,
        settlement_initiated_on: '2022-03-17T14:29:21+05:30',
        status: 'FAILED',
        utr: 'N076221079016329',
      },
    },
    event_time: '2022-03-17T14:29:23+05:30',
    // version: 1, ??
    type: 'SETTLEMENT_FAILED',
  },
  [SETTLEMENT_REVERSED]: {
    data: {
      settlement: {
        adjustment: 0,
        amount_settled: 5,
        payment_amount: 5,
        payment_from: '2022-03-17',
        payment_till: '2022-03-17',
        reason: '<REASON>',
        service_charge: 0,
        service_tax: 0,
        settled_on: '2022-03-17T14:21:18+05:30',
        settlement_amount: 5,
        settlement_id: 1155353,
        settlement_initiated_on: '2022-03-17T14:29:21+05:30',
        status: 'REVERSED',
        utr: 'N076221079016329',
      },
    },
    event_time: '2022-03-17T14:29:23+05:30',
    // version: 1, ??
    type: 'SETTLEMENT_REVERSED',
  },
  [VENDOR_SETTLEMENT_SUCCESS]: {
    data: {
      settlement: {
        adjustment: 0,
        amount_settled: 50,
        payment_amount: null,
        payment_from: '2022-04-01',
        payment_till: '2022-04-01',
        reason: null,
        service_charge: 0.25,
        service_tax: 0.05,
        settled_on: '2022-04-01T15:03:31+05:30',
        settled_orders_count: null,
        settlement_amount: 50,
        settlement_id: 3598,
        settlement_initiated_on: '2022-04-01T13:51:00+05:30',
        settlement_type: null,
        status: 'SUCCESS',
        utr: 98756789343,
        vendor_id: 46696,
        vendor_transaction_amount: 50,
      },
      event_time: '2022-04-01T16:47:12+05:30',
      type: 'VENDOR_SETTLEMENT_SUCCESS',
    },
  },
  [VENDOR_SETTLEMENT_FAILED]: {
    data: {
      settlement: {
        adjustment: 0,
        amount_settled: 50,
        payment_amount: null,
        payment_from: '2022-04-01',
        payment_till: '2022-04-01',
        reason: null,
        service_charge: 0.25,
        service_tax: 0.05,
        settled_on: '2022-04-01T15:03:31+05:30',
        settled_orders_count: null,
        settlement_amount: 50,
        settlement_id: 3598,
        settlement_initiated_on: '2022-04-01T13:51:00+05:30',
        settlement_type: null,
        status: 'SUCCESS',
        utr: 98756789343,
        vendor_id: 46696,
        vendor_transaction_amount: 50,
      },
      event_time: '2022-04-01T16:47:12+05:30',
      type: 'VENDOR_SETTLEMENT_FAILED',
    },
  },
  [VENDOR_SETTLEMENT_INITIATED]: {
    data: {
      settlement: {
        adjustment: 0,
        amount_settled: 50,
        payment_amount: null,
        payment_from: '2022-04-01',
        payment_till: '2022-04-01',
        reason: null,
        service_charge: 0.25,
        service_tax: 0.05,
        settled_on: '2022-04-01T15:03:31+05:30',
        settled_orders_count: null,
        settlement_amount: 50,
        settlement_id: 3598,
        settlement_initiated_on: '2022-04-01T13:51:00+05:30',
        settlement_type: null,
        status: 'SUCCESS',
        utr: 98756789343,
        vendor_id: 46696,
        vendor_transaction_amount: 50,
      },
      event_time: '2022-04-01T16:47:12+05:30',
      type: 'VENDOR_SETTLEMENT_INITIATED',
    },
  },
  [VENDOR_SETTLEMENT_REVERSED]: {
    data: {
      settlement: {
        adjustment: 0,
        amount_settled: 50,
        payment_amount: null,
        payment_from: '2022-04-01',
        payment_till: '2022-04-01',
        reason: null,
        service_charge: 0.25,
        service_tax: 0.05,
        settled_on: '2022-04-01T15:03:31+05:30',
        settled_orders_count: null,
        settlement_amount: 50,
        settlement_id: 3598,
        settlement_initiated_on: '2022-04-01T13:51:00+05:30',
        settlement_type: null,
        status: 'SUCCESS',
        utr: 98756789343,
        vendor_id: 46696,
        vendor_transaction_amount: 50,
      },
      event_time: '2022-04-01T16:47:12+05:30',
      type: 'VENDOR_SETTLEMENT_REVERSED',
    },
  },
  [PAYMENT_LINK]: {
    data: {
      cf_link_id: 1576977,
      link_id: 'payment_ps11',
      link_status: 'PARTIALLY_PAID',
      link_currency: 'INR',
      link_amount: '200.12',
      link_amount_paid: '55.00',
      link_partial_payments: true,
      link_minimum_partial_amount: '11.00',
      link_purpose: 'Payment for order 10',
      link_created_at: '2021-08-18T07:13:41',
      customer_details: {
        customer_phone: '9000000000',
        customer_email: 'john@gmail.com',
        customer_name: 'John ',
      },
      link_meta: {
        notify_url: 'https://ee08e626ecd88c61c85f5c69c0418cb5.m.pipedream.net',
      },
      link_url: 'https://payments-test.cashfree.com/links//U1mgll3c0e9g',
      link_expiry_time: '2021-11-28T21:46:20',
      link_notes: {
        note_key_1: 'note_value_1',
      },
      link_auto_reminders: true,
      link_notify: {
        send_sms: true,
        send_email: true,
      },
      order: {
        order_amount: '22.00',
        order_id: 'CFPay_U1mgll3c0e9g_ehdcjjbtckf',
        order_expiry_time: '2021-08-18T07:34:50',
        order_hash: 'Gb2gC7z0tILhGbZUIeds',
        transaction_id: 1021206,
        transaction_status: 'SUCCESS',
      },
    },
    type: 'PAYMENT_LINK_EVENT',
    version: '1',
    event_time: '2021-08-18T12:55:06+05:30',
  },
  [INSTRUMENT_ACTIVE]: {
    data: {
      instrument: {
        customer_id: 'siddhesh199721',
        afa_reference: '887916963',
        instrument_id: 'af950dc5-e5e5-4e7d-a7cf-3f446741fa54',
        instrument_type: 'card',
        instrument_uid:
          '680cd7171589f9f64b426983d4501d6941b462932ce5f626be78392d5ec42660',
        instrument_display: 'XXXXXXXXXXXX6854',
        instrument_status: 'ACTIVE',
        added_at: '2022-04-14T10:42:59+05:30',
        instrument_meta: {
          card_network: 'visa',
          card_bank_name: 'HDFC BANK',
          card_country: 'IN',
          card_type: 'credit',
          card_token_details: null,
        },
      },
    },
    event_time: '2022-04-14T10:44:14+05:30',
    type: 'INSTRUMENT_ACTIVE_WEBHOOK',
  },
  [PAYMENT_FORM_ORDER_WEBHOOK]: {
    data: {
      form: {
        form_id: 'my-form-1',
        cf_form_id: 2011640,
        form_url: 'https://payments-test.cashfree.com/forms/webhook-trial-1',
        form_currency: 'INR',
      },
      order: {
        order_amount: 22.0,
        order_id: 'CFPay_U1mgll3c0e9g_ehdcjjbtckf',
        order_status: 'PAID',
        transaction_id: 1021206,
        customer_details: {
          customer_phone: '9999999999',
          customer_email: 'mohit.jasapara@cashfree.com',
          customer_name: 'Mohit Jasapara',
          customer_fields: [
            {
              title: 'Zoom ID',
              value: 'mohit.jasapara',
            },
            {
              title: 'Company Designation',
              value: '',
            },
          ],
        },
        amount_details: [
          {
            title: 'Webinar Tickets',
            value: 398,
            quantity: 2,
          },
          {
            title: 'Zoom Platform Fee',
            value: 10,
          },
          {
            title: 'Buy me a coffee :)',
            value: 0,
          },
          {
            title: 'Amount Dropdown Trial',
            value: 50,
            selectedoption: 'Option 1',
          },
        ],
      },
    },
    event_time: '2021-04-16T14:10:36+05:30',
    type: 'PAYMENT_FORM_ORDER_WEBHOOK',
  },
  [PAYMENT_LINK_EVENT]: {
    data: {
      cf_link_id: 1576977,
      link_id: 'payment_ps11',
      link_status: 'PARTIALLY_PAID',
      link_currency: 'INR',
      link_amount: '200.12',
      link_amount_paid: '55.00',
      link_partial_payments: true,
      link_minimum_partial_amount: '11.00',
      link_purpose: 'Payment for order 10',
      link_created_at: '2021-08-18T07:13:41',
      customer_details: {
        customer_phone: '9000000000',
        customer_email: 'john@gmail.com',
        customer_name: 'John ',
      },
      link_meta: {
        notify_url: 'https://ee08e626ecd88c61c85f5c69c0418cb5.m.pipedream.net',
      },
      link_url: 'https://payments-test.cashfree.com/links//U1mgll3c0e9g',
      link_expiry_time: '2021-11-28T21:46:20',
      link_notes: {
        note_key_1: 'note_value_1',
      },
      link_auto_reminders: true,
      link_notify: {
        send_sms: true,
        send_email: true,
      },
      order: {
        order_amount: '22.00',
        order_id: 'CFPay_U1mgll3c0e9g_ehdcjjbtckf',
        order_expiry_time: '2021-08-18T07:34:50',
        order_hash: 'Gb2gC7z0tILhGbZUIeds',
        transaction_id: 1021206,
        transaction_status: 'SUCCESS',
      },
    },
    type: 'PAYMENT_LINK_EVENT',
    version: '1',
    event_time: '2021-08-18T12:55:06+05:30',
  },
  [SUBSCRIPTIONS_WEBHOOK]: {
    data: {
      form: {
        cf_event: 'SUBSCRIPTION_STATUS_CHANGE',
        cf_merchantId: '123456',
        cf_subReferenceId: '123456',
        cf_status: 'COMPLETED',
        cf_lastStatus: 'ACTIVE',
        cf_eventTime: '2022-12-21 14:41:00',
        signature: 'idsugUBNIfisn+sangi8d/asigns',
      },
    },
    type: 'SUBSCRIPTIONS_WEBHOOK',
    version: '1',
    event_time: '2022-12-26T12:55:06+05:30',
  },
};

export const DEFAULT_CF_API_VERSION = '0';

export const VERSION_MAPPING = {
  '0': 'Version 0',
  '2021-09-21': 'Version 1',
  '2022-09-01': 'Version 2',
};

export const PAYMENTS_WEBHOOK_VERSION_DATA = [
  {
    key: PAYMENTS_WEBHOOK_VERSION_2021,
    text: '2021-09-21',
    value: PAYMENTS_WEBHOOK_VERSION_2021,
  },
  {
    key: PAYMENTS_WEBHOOK_VERSION_2022,
    text: '2022-09-01',
    value: PAYMENTS_WEBHOOK_VERSION_2022,
  },
  {
    key: PAYMENTS_WEBHOOK_VERSION_2022_1,
    text: ' 2022-02-09',
    value: PAYMENTS_WEBHOOK_VERSION_2022_1,
  },
  {
    key: PAYMENTS_WEBHOOK_VERSION_2025,
    text: '2025-01-01',
    value: PAYMENTS_WEBHOOK_VERSION_2025,
  },
];

export const SUBSCRIPTIONS_WEBHOOK_VERSION_DATA = [
  {
    key: SUBSCRIPTIONS_WEBHOOK_VERSION_2023,
    text: '2023-08-01',
    value: SUBSCRIPTIONS_WEBHOOK_VERSION_2023,
  },
  {
    key: SUBSCRIPTIONS_WEBHOOK_VERSION_2025,
    text: '2025-01-01',
    value: SUBSCRIPTIONS_WEBHOOK_VERSION_2025,
  },
  {
    key: SUBSCRIPTIONS_WEBHOOK_VERSION_2022,
    text: 'N/A - to be deprecated',
    value: SUBSCRIPTIONS_WEBHOOK_VERSION_2022,
  },
];

export const TRANSACTION_WEBHOOK_VERSION_DATA = [
  {
    key: PAYMENTS_WEBHOOK_VERSION_2022,
    text: '2022-09-01',
    value: PAYMENTS_WEBHOOK_VERSION_2022,
  },
  {
    key: PAYMENTS_WEBHOOK_VERSION_2023,
    text: '2023-08-01',
    value: PAYMENTS_WEBHOOK_VERSION_2023,
  },
  {
    key: PAYMENTS_WEBHOOK_VERSION_2025,
    text: '2025-01-01',
    value: PAYMENTS_WEBHOOK_VERSION_2025,
  },
];

export const NOTIFY_URL_EVENTS = [
  SUCCESS_PAYMENT,
  FAILED_PAYMENT,
  USER_DROPPED_PAYMENT,
  SUCCESS_PAYMENT_TDR,
];

export const DEFAULT = 'DEFAULT';
export const FIXED = 'FIXED';
export const EXPONENTIAL = 'EXPONENTIAL';
export const CUSTOM = 'CUSTOM';

export const POLICY_RADIO_OPTIONS = {
  label: 'Select Retry Policy',
  radioOptions: [
    [
      {
        label: 'Default',
        name: 'retryType',
        value: DEFAULT,
      },
      {
        label: 'Fixed',
        name: 'retryType',
        value: FIXED,
      },
      {
        label: 'Exponential',
        name: 'retryType',
        value: EXPONENTIAL,
      },
      {
        label: 'Custom',
        name: 'retryType',
        value: CUSTOM,
      },
    ],
    [
      {
        label: 'Default',
        name: 'retryType',
        value: DEFAULT,
      },
      {
        label: 'Fixed',
        name: 'retryType',
        value: FIXED,
      },
      {
        label: 'Exponential',
        name: 'retryType',
        value: EXPONENTIAL,
      },
      {
        label: 'Custom',
        name: 'retryType',
        value: CUSTOM,
      },
    ],
    [
      {
        label: 'Default',
        name: 'retryType',
        value: DEFAULT,
      },
      {
        label: 'Fixed',
        name: 'retryType',
        value: FIXED,
      },
      {
        label: 'Exponential',
        name: 'retryType',
        value: EXPONENTIAL,
      },
      {
        label: 'Custom',
        name: 'retryType',
        value: CUSTOM,
      },
    ],
    [
      {
        label: 'Default',
        name: 'retryType',
        value: DEFAULT,
      },
      {
        label: 'Fixed',
        name: 'retryType',
        value: FIXED,
      },
      {
        label: 'Exponential',
        name: 'retryType',
        value: EXPONENTIAL,
      },
      {
        label: 'Custom',
        name: 'retryType',
        value: CUSTOM,
      },
    ],
  ],
};

export const TIME_UNIT = [
  {
    key: 'SECONDS',
    text: 'Seconds',
    value: 'SECONDS',
  },
  {
    key: 'MINUTES',
    text: 'Minutes',
    value: 'MINUTES',
  },
  {
    key: 'HOURS',
    text: 'Hours',
    value: 'HOURS',
  },
  {
    key: 'DAYS',
    text: 'Days',
    value: 'DAYS',
  },
];

export const DEFAULT_POLICY_LIST = {
  DEFAULT: {
    retryType: DEFAULT,
    maxRetryAttempts: 3,
    timeUnit: 'MINUTES',
    retryInterval: [2, 10, 30],
    intervalValue: 2,
    multiplier: 1,
  },
  FIXED: {
    retryType: FIXED,
    maxRetryAttempts: 5,
    timeUnit: 'MINUTES',
    retryInterval: [15, 30, 45, 60, 75],
    intervalValue: 15,
    multiplier: 1,
  },
  EXPONENTIAL: {
    retryType: EXPONENTIAL,
    maxRetryAttempts: 5,
    timeUnit: 'MINUTES',
    retryInterval: [15, 17, 19, 23, 31],
    intervalValue: 15,
    multiplier: 2,
  },
  CUSTOM: {
    retryType: 'CUSTOM',
    maxRetryAttempts: 3,
    timeUnit: 'MINUTES',
    retryInterval: [2, 10, 30],
    multiplier: 1,
  },
};

export const ConfigTimelines = ['Endpoint Details', 'Add Policy', 'Summary'];

export const EDIT = 'Edit';

export const TEST = 'Test';

export const TEST_VALUE = 'test_value';

export const SUCCESS = 'success';

export const ERROR = 'error';

export const NEXT = 'Next';

export const ADD_WEBHOOK = 'Add Webhook';

export const CONTINUE = 'Continue';

export const DONE = 'Done';

export const SAVE = 'Save';

export const POLICY_LIST_TYPE = [DEFAULT, FIXED, EXPONENTIAL, CUSTOM];

export const EDIT_MOCK_DATA = {
  channelValue: 'test1.cashfree.com',
  cfApiVersion: '2022-09-01',
  merchantNotificationTypeDetailsResponse: [
    {
      notificationType: 'REFUND',
      isActive: true,
      notificationChannel: 'WEBHOOK',
      status: null,
      retryPolicy: {
        retryType: 'FIXED',
        maxRetryAttempts: 3,
        multiplier: 1,
        timeUnit: 'MINUTES',
        retryInterval: [1, 2, 5],
        status: 'ACTIVE',
      },
    },
    {
      notificationType: 'SUCCESS_PAYMENT',
      isActive: true,
      notificationChannel: 'WEBHOOK',
      status: 'UNVERIFIED',
      retryPolicy: {
        retryType: 'DEFAULT',
        maxRetryAttempts: 3,
        multiplier: 1,
        timeUnit: 'MINUTES',
        retryInterval: [1, 2, 5],
        status: 'ACTIVE',
      },
    },
    {
      notificationType: 'DISPUTE_CLOSED',
      isActive: false,
      notificationChannel: 'WEBHOOK',
      status: 'UNVERIFIED',
      retryPolicy: {
        retryType: 'DEFAULT',
        maxRetryAttempts: 3,
        multiplier: 1,
        timeUnit: 'MINUTES',
        retryInterval: [1, 2, 5],
        status: 'ACTIVE',
      },
    },
  ],
};
export const SEPERATE_WEBHOOKS = [PAYMENT_LINK, PAYMENT_FORM];

export const NOTIFY_URL_EDIT_ACTION_HOVER_TEXT =
  "This cannot be edited. Webhook will only be sent for a payment if notify_url is received in 'Create Order' API for that payment";

export const NOTIFY_URL_DELETE_ACTION_HOVER_TEXT =
  "This cannot be deleted. Webhook will only be sent for a payment if notify_url is received in 'Create Order' API for that payment";

export const ABANDONED_CHECKOUT_DOC =
  'https://www.cashfree.com/docs/payments/checkout/abandoned-checkout/webhook';
